<template>
  <div class="p-create-test">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item
        v-if="isFromTestCenter"
        :to="{ path: '/pt/test-center' }">测评中心</el-breadcrumb-item>
      <el-breadcrumb-item
        v-else
        :to="{ path: '/pt/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>创建测评</el-breadcrumb-item>
    </el-breadcrumb>
    <card-header class="mt-23">创建测评</card-header>
    <el-form class="mt-40" label-width="110px">
      <el-form-item
        label="测评名称："
        required
        :class="errorProp==='name'?'is-error':''"
      >
        <el-col :span="6">
          <el-input
            placeholder="例如：章节三《二元一次方程组》测评"
            maxlength="30"
            v-model="searchForm.name"
          ></el-input>
        </el-col>
        <el-col
           style="margin-left:10px;color:rgba(144, 147, 153, 1);"
          :span="10">{{searchForm.name.length}}/30</el-col>
      </el-form-item>
      <el-form-item label="测试课程：" required class="multi-line-form">
        <el-select
          no-data-text="暂无可选学科"
          v-model="searchForm.subject"
          class="mr-16"
          placeholder="选择学科" :class="errorProp==='subject'?'is-error':''"
          value-key="id"
        >
            <el-option
              v-for="item in subjectList"
              :value="item"
              :key="item.id"
              :label="item.name">
            </el-option>
          </el-select>
        <el-select
          v-model="searchForm.version"
          placeholder="选择版本"
          no-data-text="请先选择学科"
          class="mr-16"
          :class="errorProp==='version'?'is-error':''"
          value-key="id"
        >
          <el-option
            v-for="item in versionList"
            :key="item.id"
            :label="item.name"
            :value="item"
          ></el-option>
        </el-select>
        <el-select
          v-model="searchForm.stage"
          placeholder="选择年级"
          no-data-text="请先选择版本"
          class="mr-16"
         :class="errorProp==='stage'?'is-error':''"
         value-key="dl_code"
        >
          <el-option
            v-for="item in stageList"
            :key="item.id"
            :label="item.name"
            :value="item"
          ></el-option>
        </el-select>
        <el-select
          v-model="searchForm.course"
          placeholder="选择测试"
          :no-data-text="emptyCourseText"
         class="mr-16" :class="errorProp==='course'?'is-error':''"
         value-key="id"
        >
          <el-option
            v-for="item in courseList"
            :key="item.id"
            :label="item.name"
            :value="item"
          ></el-option>
        </el-select>
      </el-form-item>
      <div class="test-time" v-if="searchForm.course">
        本测评共{{knowledge_num}}个知识点，预计用时{{estimated_time}}分钟</div>
      <el-form-item label="测评对象：" class="multi-line-object" required>
        <el-col :span="5">
          <el-cascader
            ref="cascader"
            :options="gradeList"
            style="width:100%"
            separator=""
            :props="{multiple:true, value: 'dl_code', label: 'name', children: 'class_infos'}"
            :class="errorProp==='targets'?'is-error':''"
            v-model="searchForm.targets"
            popper-class="c-cascader"
            @change="handleChange"
          >
          <template slot-scope="{ node, data }">
            <span>{{ data.name }}</span>
            <span
              v-if="!node.isLeaf&&getSelectedCount(data.academic_year_id)"
              class="c-cascader__count">
                {{ getSelectedCount(data.academic_year_id) }}
            </span>
          </template>
          </el-cascader>
        </el-col>
      </el-form-item>
    </el-form>
    <footer class="p-create__footer mt-40">
      <p class="p-create__error"
        :style="{visibility: errorMessage?'visible':'hidden'}">
        *{{errorMessage}}
      </p>
      <el-button class="p-create__button" @click="onCancelClick">取 消</el-button>
      <el-button type="primary" class="p-create__button" @click="onCreateClick">创 建</el-button>
    </footer>
  </div>
</template>

<script>
import CardHeader from '@/components/card-header.vue';
import {
  createEvaluate, getTeacherClassYear, getLastInfo, getTestInfo,
} from '@/api/pt';
import mixins from './mixins';
import { formatTimeBySubject } from '@/utils/index';

export default {
  components: { CardHeader },
  name: 'CreateTest',
  mixins: [mixins],
  data() {
    return {
      loading: false,
      // 没有课程
      emptyCourse: false,
      errorProp: '',
      searchForm: {
        name: '',
        subject: '',
        version: '',
        stage: '',
        course: '',
        targets: '',
      },
      subjectList: [],
      versionList: [],
      stageList: [],
      gradeList: [],
      courseList: [],
      formedTargets: '',
      knowledge_num: '',
      estimated_time: '',
    };
  },
  computed: {
    isFromTestCenter() {
      return this.$route.query.from === 'test-center';
    },
    emptyCourseText() {
      return this.emptyCourse ? '暂无测试内容' : '请先选择年级';
    },
    errorMessage() {
      const map = {
        name: '请输入测评名称',
        subject: '请选择学科',
        version: '请选择版本',
        stage: '请选择年级',
        course: '请选择测试内容',
        targets: '请选择测评对象',
      };
      return `${map[this.errorProp] || ''}`;
    },
  },
  watch: {
    'searchForm.course': function reset(v) {
      console.log(v);
      if (v.kmap_code) {
        // console.log(v.kmap_code);
        // console.log(this.searchForm.subject.id);
        const params = {
          kmap_code: v.kmap_code,
        };
        getTestInfo(params).then((res) => {
          // console.log(res, 'res');
          this.knowledge_num = res.data;
          this.estimated_time = formatTimeBySubject(this.searchForm.subject.id, this.knowledge_num);
        });
      }
    },
  },
  activated() {
    this.errorProp = '';
    this.reset();
    this.getCategory({
      type: 'subjects',
    });
    this.getTeacherClassYear();
    // 查询最后一次作业的班级信息
    this.queryLastInfo();
  },
  mounted() {
    this.errorProp = '';
    this.reset();
    this.getCategory({
      type: 'subjects',
    });
    this.getTeacherClassYear();
    // 查询最后一次作业的班级信息
    this.queryLastInfo();
  },
  methods: {
    handleChange() {
      this.$nextTick(() => {
        this.formedTargets = this.$refs.cascader.checkedNodes.map((item) => ({
          grade_id: item.path[0],
          class_id: item.path[1],
          class_name: item.pathLabels[1],
          school_year: item.pathLabels[0],
        }));
      });
    },
    // 查询最后一次作业的班级信息
    async queryLastInfo() {
      await getLastInfo({
        type: 1,
      }).then((res) => {
        if (res.code === 200) {
          // this.queryLastData = res.data;
          if (res.data.evaluate_object.length > 0) {
            const classList = [];
            res.data.evaluate_object.forEach((item) => {
              classList.push([String(item.grade_id), String(item.class_id)]);
            });
            this.searchForm.targets = classList;
            this.formedTargets = res.data.evaluate_object.map((item) => ({
              grade_id: item.grade_id,
              class_id: item.class_id,
              class_name: item.class_name,
              school_year: item.school_year,
            }));
          }
        }
      });
    },

    onCancelClick() {
      this.$router.go(-1);
    },
    reset() {
      this.searchForm = {
        name: '',
        subject: '',
        version: '',
        stage: '',
        course: '',
        targets: '',
      };
    },
    setTargets() {
      const { classId, gradeId } = this.$route.query;
      if (gradeId && classId) {
        this.searchForm.targets = [[gradeId, classId]];
      }
    },
    getTeacherClassYear() {
      return getTeacherClassYear().then((res) => {
        if (res.code === 200) {
          this.gradeList = res.data;
          this.setTargets();
        }
      });
    },
    // 获取对应年级下已经选择的班级数量
    getSelectedCount(id) {
      if (!this.searchForm.targets) {
        return 0;
      }
      const len = this.$refs.cascader.checkedNodes
        .filter((item) => item.pathNodes[0].data.academic_year_id === id).length;
      return len;
    },
    onCreateClick() {
      console.log(this.formedTargets, 44444444);
      if (this.loading) {
        return;
      }
      if (this.checkForm()) {
        this.errorProp = '';
        this.loading = true;
        createEvaluate({
          evaluate_name: this.searchForm.name,
          subject_id: this.searchForm.subject.id,
          textbook_id: this.searchForm.version.id,
          test_grade_id: this.searchForm.stage.id,
          test_id: this.searchForm.course.id,
          test_name: this.searchForm.course.name,
          app_id: 1,
          type: 1,
          is_sync: 0,
          evaluate_object: JSON.stringify(this.formedTargets),
          dl_kmap_code: this.searchForm.course.kmap_code,
          dl_question_level: this.searchForm.course.question_level,
          dl_status: this.searchForm.course.status,
          dl_code: this.searchForm.course.code,
        }).then((res) => {
          if (res.code === 200) {
            this.$router.push({
              path: '/pt/create-test-success',
            });
          } else {
            this.$message({
              type: 'warning',
              message: res.msg,
            });
          }
        }).catch((e) => {
          console.log(e);
          this.$message({
            type: 'warning',
            message: e.msg,
          });
        }).finally(() => {
          this.loading = false;
        });
      }
    },
    checkForm() {
      const keys = Object.keys(this.searchForm);
      console.log('查看这个key', this.searchForm);
      return keys.every((key) => {
        if (this.searchForm[key] && this.searchForm.targets.length > 0) {
          return true;
        }
        if (this.searchForm[key] && this.searchForm.targets.length < 1) {
          this.errorProp = 'targets';
          return false;
        }

        this.errorProp = key;
        return false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.p-create-test {
  padding: 32px 32px 100px;
  height: 100%;
  box-sizing: border-box;
  overflow-y: auto;
  background: #fff;
  position: relative;
  .test-time{
    margin-top: -10px;
    margin-left: 110px;
  }
  /deep/ .el-form-item__label {
    font-weight: bold;
  }
  .p-create__error {
    color: rgba(245, 108, 108, 1);
    font-size: 14px;
    line-height: 2;
  }
  .p-create__footer {
    padding-left: 110px;
  }
  .p-create__button {
    width: 120px;
  }
  /deep/ .is-error .el-input__inner {
    border: 1px solid #F56C6C;
  }
}
.multi-line-form {
  /deep/ {
    .el-form-item__content {
      margin-top: -16px;
    }
    .el-select {
      margin-top: 16px;
    }
  }
}
.multi-line-object{
  margin-top: 10px;
}
</style>
